/** Left sidebar modes (Browse rail, Documents tree, Inbox, Flows, Chats, Drive). */
export type SidebarPrimaryMode =
  | 'browse-nav'
  | 'documents-tree'
  | 'inbox'
  | 'flows'
  | 'chats'
  | 'drive'

const SIDEBAR_MODE_EVENT = 'flownotes-sidebar-mode'

/** Open the left sidebar Inbox or Flows panel without changing the main document tab. */
export function openSidebarMode(mode: SidebarPrimaryMode): void {
  window.dispatchEvent(
    new CustomEvent(SIDEBAR_MODE_EVENT, { detail: { mode } }),
  )
}

export function sidebarModeEventName(): string {
  return SIDEBAR_MODE_EVENT
}
